import { useQuery } from "@tanstack/react-query";

const sleep = (ms = 1000) => new Promise((resolve) => setTimeout(resolve, ms));
const useDelayedQuery = ({ queryKey, queryFn, placeholderData = [], enabled = true }) => {
  return useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      await sleep(500);
      if (!signal?.aborted) {
        return queryFn();
      }
    },
    placeholderData,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
    refetchOnWindowFocus: false,
    enabled,
  });
};

export default useDelayedQuery;
